import { FunnelFlowConfig, quiz, screen } from 'funnel/src/app/flow/flow-config';

export const shortFunnelFlow: FunnelFlowConfig = {
  screens: [
    screen('intro'),

    quiz('format'),

    quiz('amountInfo'),
    quiz('goals'),
    quiz('time'),
    quiz('goalInfo'),

    quiz('demo1'),
    quiz('demo2'),
    quiz('demo3'),
    quiz('demo4'),

    screen('login'),
    screen('ready'),
    screen('paywall'),
  ],
};
